export class JsFormError extends Error {
    constructor(public message: string) {
        super(message);
        this.name = 'JsFormError';
        Object.setPrototypeOf(this, JsFormError.prototype);
    }
}
